import { EditorFiltrosUnidades } from './EditorFiltrosUnidades'
import { textoAgendamento, textosAgendamento } from './textos'
import { criarConversor, criarEditorTelaFixa } from './telaFixaAgendavel'
import { EditorFiltrosTiposSepulturas, filtrosTiposSepulturasDoRecord } from './tiposSepulturasAgendavel'
import { FalecidosRelatorioForm } from '../../pages/falecidosRelatorio/form/FalecidosRelatorioForm'
import { ExumacoesRelatorioForm } from '../../pages/exumacoesRelatorio/form/ExumacoesRelatorioForm'
import { AquisicoesRelatorioForm } from '../../pages/aquisicoesRelatorio/form/AquisicoesRelatorioForm'
import { CartaoCreditoRelatorioForm } from '../../pages/cartaoCreditoRelatorio/form/CartaoCreditoRelatorioForm'
import { ConsultaBaixaRelatorioForm } from '../../pages/consultaBaixaRelatorio/form/ConsultaBaixaRelatorioForm'
import { LivroCaixaForm } from '../../pages/livroCaixa/form/LivroCaixaForm'
import { ReceitasDespesasRelatorioForm } from '../../pages/receitasDespesasRelatorio/form/ReceitasDespesasRelatorioForm'
import { ContasReceberRelatorioForm } from '../../pages/contasReceberRelatorio/form/ContasReceberRelatorioForm'
import { IsentosRelatorioForm } from '../../pages/isentosRelatorio/form/IsentosRelatorioForm'
import { SepulturasDevedorasRelatorioForm } from '../../pages/sepulturasDevedorasRelatorio/form/SepulturasDevedorasRelatorioForm'
import { acoes, enums, LANCAMENTO_PAGO } from '../../constants'
import apiService from '../../services/api.service'
import apiIdValue from '../../services/api-id-value-service'
import storage from '../../services/stoage.service'
import utils from '../../utils'

const DATAS_PERIODO = [
  { campo: 'dataInicial', label: 'data.inicial' },
  { campo: 'dataFinal', label: 'data.final' },
]

// telas cujo back recebe o RelatorioParams: unidades e tipos de sepultura em lista, datas do periodo
const unidadesETipos = criarConversor({
  listas: { unidade: 'unidades', tiposSepulturas: 'tiposSepulturas' },
  simples: ['dataInicial', 'dataFinal'],
})

// isentos e sepulturas devedoras: sem datas (o agendamento e so pelo cron). O conspaga das devedoras nao passa pelo
// conversor: fica fora do record da tela (ver filtroConspagaDoEstado)
const unidadesETiposSemDatas = criarConversor({
  listas: { unidade: 'unidades', tiposSepulturas: 'tiposSepulturas' },
})

// consulta de baixa: so a unidade e o periodo
const soUnidades = criarConversor({ listas: { unidade: 'unidades' }, simples: ['dataInicial', 'dataFinal'] })

// as formas de pagamento da empresa, como o container das telas monta (status pago traz tambem as da Stone)
const formasPagamentoDaEmpresa = () =>
  utils.getFormasPagamento(
    enums.FormasPagamento,
    utils.getConfiguracaoFormasPagamento(storage.getCompany(), null),
    LANCAMENTO_PAGO
  )

// contas correntes das unidades escolhidas (sem unidade, as da empresa), como a tela do livro caixa carrega
const carregarContasCorrentes = (unidades) => {
  const idsUnidades = (unidades || []).map((unidade) => unidade.id).filter((id) => id > 0)
  const consultas = (idsUnidades.length > 0 ? idsUnidades : [-1]).map((id) => apiIdValue.getContasCorrentes(id))
  return Promise.all(consultas).then((respostas) => {
    const contas = []
    respostas.forEach((resposta) => {
      ;(resposta.data || []).forEach((conta) => {
        if (!contas.some((existente) => existente.id === conta.id)) {
          contas.push(conta)
        }
      })
    })
    return contas
  })
}

const carregarUsuariosBaixa = (unidades) =>
  apiService.post('/lottustech/usuarios/baixa', unidades || []).then((resposta) => resposta.data || [])

// grupos financeiros das unidades escolhidas, como as telas de receitas/despesas e contas a receber carregam
const carregarGruposFinanceiros = (unidades) => {
  const idsUnidades = (unidades || []).map((unidade) => unidade.id)
  const filtros =
    idsUnidades.length > 0 ? [{ campo: 'unidade', valor: idsUnidades, tipoFiltro: 'ESTA_CONTIDO_EM' }] : []
  return apiService
    .post('/lottustech/gruposfinanceiros/all', {
      index: 0,
      max: 1000,
      projectionFields: ['oid', 'descricao'],
      filters: filtros,
    })
    .then((resposta) =>
      ((resposta.data && resposta.data.records) || []).map((grupo) => ({
        id: grupo.oid,
        value: `${grupo.oid} - ${grupo.descricao}`,
      }))
    )
}

// receitas/despesas e contas a receber: forma de pagamento e grupo financeiro vao so com os ids. Sem forma de
// pagamento marcada o back manda todas as da empresa no dia do envio; sem grupo financeiro o relatorio traz todos
const financeiro = (simples) =>
  criarConversor({
    listas: { unidade: 'unidades', tiposSepulturas: 'tiposSepulturas' },
    ids: {
      tipoFormaPagamento: { filtro: 'formasPagamentos', opcoes: formasPagamentoDaEmpresa },
      gruposFinanceiros: {
        filtro: 'gruposFinanceiros',
        opcoes: (carregadas) => carregadas.gruposFinanceirosOpcoes,
      },
    },
    simples,
  })

const receitasDespesas = financeiro(['dataInicial', 'dataFinal', 'tipoRelatorio'])
const contasReceber = financeiro(['dataInicial', 'dataFinal', 'dataVencimentoInicial', 'dataVencimentoFinal'])

const editorFinanceiro = (Form, conversor) =>
  criarEditorTelaFixa(Form, conversor, {
    outrasListas: [
      { campo: 'gruposFinanceirosOpcoes', filtroIds: 'gruposFinanceiros', carregar: carregarGruposFinanceiros },
    ],
    propsForm: () => ({ formasPagamento: formasPagamentoDaEmpresa() }),
  })

// livro caixa: o back recebe o LivroCaixaParams. Sem forma de pagamento marcada o back manda todas as da empresa
const livroCaixa = criarConversor({
  listas: {
    unidade: 'unidades',
    tiposSepulturas: 'tiposSepulturas',
    usuariosBaixa: 'usuariosBaixa',
    contasCorrentes: 'contas',
  },
  ids: {
    tipoFormaPagamento: { filtro: 'formasPagamentos', opcoes: formasPagamentoDaEmpresa },
  },
  simples: ['dataInicial', 'dataFinal', 'hasTotalizadores'],
  renomeados: { isDetalhado: 'detalhado' },
})

const CAMPO_CONSPAGA = 'conspaga'

/**
 * Sepulturas devedoras: o filtro de conspaga fica no estado do container da tela, fora do record. Para o botao
 * Agendar a tela entrega esse estado em record.estadoConspaga; aqui ele vira o que o "Visualizar" manda.
 */
export const filtroConspagaDoEstado = (estado) =>
  estado && estado.tipoFiltro
    ? {
        tipoFiltro: estado.tipoFiltro.value,
        campo: CAMPO_CONSPAGA,
        valor: estado.conspagaInicial,
        valorComplementar: estado.conspagaFinal,
      }
    : undefined

/** O caminho de volta: o estado que o formulario da tela espera, a partir do filtro gravado. */
export const estadoConspagaDoFiltro = (filtro, tiposFiltros) => {
  const gravado = filtro || {}
  const tipoFiltro = tiposFiltros.find((tipo) => tipo.value === gravado.tipoFiltro) || tiposFiltros[0]
  return {
    tipoFiltro,
    conspagaInicial: gravado.valor,
    conspagaFinal: gravado.valorComplementar,
    mostrarAnoInicial: tipoFiltro.dataInicial,
    mostrarAnoFinal: tipoFiltro.dataFinal,
  }
}

// o que o formulario de sepulturas devedoras recebe do container para o filtro de conspaga
const propsConspaga = (filtros, onChange, { tiposFiltros }) => {
  const alterar = (mudanca) =>
    onChange('filtroConspaga', { ...(filtros.filtroConspaga || {}), campo: CAMPO_CONSPAGA, ...mudanca })
  return {
    state: { filtroConspaga: estadoConspagaDoFiltro(filtros.filtroConspaga, tiposFiltros) },
    changeTipoFiltroConspaga: (evento) => alterar({ tipoFiltro: evento.value.value }),
    changeAnoConspaga: (evento) => {
      const ano = parseInt(evento.target.value)
      alterar({
        [evento.target.name === 'conspagaInicial' ? 'valor' : 'valorComplementar']: Number.isNaN(ano)
          ? new Date().getFullYear()
          : ano,
      })
    },
  }
}

const filtrosSepulturasDevedoras = (record = {}) => {
  const filtros = unidadesETiposSemDatas.filtrosDoRecord(record)
  const filtroConspaga = filtroConspagaDoEstado(record.estadoConspaga)
  return filtroConspaga ? { ...filtros, filtroConspaga } : filtros
}

/** Tela com unidade, tipos de sepultura e periodo (a maioria das telas fixas). */
const telaComUnidadesETipos = (descricao, Form) => ({
  descricao,
  camposData: DATAS_PERIODO,
  EditorFiltros: criarEditorTelaFixa(Form, unidadesETipos),
  filtrosDaTela: unidadesETipos.filtrosDoRecord,
})

/**
 * Telas de relatorio fixas que podem ser agendadas, pelo path gravado no agendamento. Usado pela tela do relatorio
 * (botao Agendar) e pela listagem (editar). Cada entrada nova tambem precisa do executor no back e de entrar no
 * CHECK ck_agendamento_relatorio_origem. Textos por chave do dicionario (agendamentorelatorio.label.*).
 * - descricao: chave do nome do relatorio
 * - camposData: linhas da grade de datas, com a chave do rotulo
 * - EditorFiltros: edita os filtros que nao sao data (opcional)
 * - filtrosDaTela(record): os filtros a partir do registro da tela, para o botao Agendar (telas do cadastro comum
 *   do back, TelasFixasAgendaveis; o DRE monta os dele na propria tela)
 */
const RELATORIOS_AGENDAVEIS = {
  dre: {
    descricao: 'relatorio.dre',
    camposData: [
      { campo: 'dataInicial', label: 'dre.dataInicial' },
      { campo: 'dataFinal', label: 'dre.dataFinal' },
    ],
    EditorFiltros: EditorFiltrosUnidades,
  },
  falecidos: telaComUnidadesETipos('relatorio.falecidos', FalecidosRelatorioForm),
  exumacoes: telaComUnidadesETipos('relatorio.exumacoes', ExumacoesRelatorioForm),
  aquisicoes: telaComUnidadesETipos('relatorio.aquisicoes', AquisicoesRelatorioForm),
  cartaocredito: telaComUnidadesETipos('relatorio.cartaocredito', CartaoCreditoRelatorioForm),
  consultabaixa: {
    descricao: 'relatorio.consultabaixa',
    camposData: DATAS_PERIODO,
    EditorFiltros: criarEditorTelaFixa(ConsultaBaixaRelatorioForm, soUnidades, { tiposSepulturas: false }),
    filtrosDaTela: soUnidades.filtrosDoRecord,
  },
  receitasdespesas: {
    descricao: 'relatorio.receitasdespesas',
    camposData: DATAS_PERIODO,
    EditorFiltros: editorFinanceiro(ReceitasDespesasRelatorioForm, receitasDespesas),
    filtrosDaTela: receitasDespesas.filtrosDoRecord,
  },
  contasreceber: {
    descricao: 'relatorio.contasreceber',
    camposData: [
      { campo: 'dataInicial', label: 'data.emissao.inicial' },
      { campo: 'dataFinal', label: 'data.final' },
      { campo: 'dataVencimentoInicial', label: 'data.vencimento.inicial' },
      { campo: 'dataVencimentoFinal', label: 'data.final' },
    ],
    EditorFiltros: editorFinanceiro(ContasReceberRelatorioForm, contasReceber),
    filtrosDaTela: contasReceber.filtrosDoRecord,
  },
  isentos: {
    descricao: 'relatorio.isentos',
    camposData: [],
    EditorFiltros: criarEditorTelaFixa(IsentosRelatorioForm, unidadesETiposSemDatas),
    filtrosDaTela: unidadesETiposSemDatas.filtrosDoRecord,
  },
  sepulturasdevedoras: {
    descricao: 'relatorio.sepulturasdevedoras',
    camposData: [],
    EditorFiltros: criarEditorTelaFixa(SepulturasDevedorasRelatorioForm, unidadesETiposSemDatas, {
      propsForm: () => ({ tiposFiltros: utils.getFilters(storage.getAppLabels('filtros')) }),
      propsDosFiltros: propsConspaga,
    }),
    filtrosDaTela: filtrosSepulturasDevedoras,
  },
  // tipos de sepultura: filtros de localizacao em cascata, com editor proprio (o path e o endpoint da tela)
  relatoriotipossepulturas: {
    descricao: 'relatorio.relatoriotipossepulturas',
    camposData: [],
    EditorFiltros: EditorFiltrosTiposSepulturas,
    filtrosDaTela: filtrosTiposSepulturasDoRecord,
  },
  livrocaixa: {
    descricao: 'relatorio.livrocaixa',
    camposData: DATAS_PERIODO,
    EditorFiltros: criarEditorTelaFixa(LivroCaixaForm, livroCaixa, {
      outrasListas: [
        { campo: 'opcoesContasCorrentes', filtro: 'contas', carregar: carregarContasCorrentes },
        { campo: 'opcoesUsuarioBaixa', filtro: 'usuariosBaixa', carregar: carregarUsuariosBaixa },
      ],
      propsForm: () => ({
        messages: storage.getAppLabels('relatorio.livro.caixa'),
        formasPagamento: formasPagamentoDaEmpresa(),
        filtraUsuarioBaixa: storage.getAcao(acoes.CAIXA_USUARIO),
      }),
    }),
    filtrosDaTela: livroCaixa.filtrosDoRecord,
  },
}

/**
 * O relatorio agendavel do path, com os textos ja resolvidos; null se o path nao estiver registrado.
 *
 * @param textos os textos do dicionario ja carregados (opcional; ver textoAgendamento)
 */
export const getRelatorioAgendavel = (path, textos = textosAgendamento()) => {
  const registro = RELATORIOS_AGENDAVEIS[path]
  if (!registro) {
    return null
  }
  return {
    descricao: textoAgendamento(registro.descricao, textos),
    camposData: registro.camposData.map(({ campo, label }) => ({ campo, label: textoAgendamento(label, textos) })),
    EditorFiltros: registro.EditorFiltros,
    filtrosDaTela: registro.filtrosDaTela,
  }
}

/** Se o path tem dialogo registrado (sem resolver textos). */
export const isRelatorioAgendavel = (path) => Boolean(RELATORIOS_AGENDAVEIS[path])
